'use client';

import { useRef } from 'react';
import { useTranslations } from 'next-intl';
import { RareLogo } from './RareLogo';
import styles from './Footer.module.css';

export const Footer = () => {
  const logoRef = useRef<SVGSVGElement>(null);
  const t = useTranslations('ring');

  return (
    <footer className={styles.root}>
      <div>
        <h2>{t.rich('ring.rare.footer.heading', { br: () => <br /> })}</h2>
        <RareLogo fill={'#ffffff'} ref={logoRef} />
      </div>
    </footer>
  );
};
